import React, { useRef, useState } from 'react'
import { Tabs, Swiper, SafeArea } from 'antd-mobile'
import Community from './Community'
import Session from './Session'
import Conversation from './Conversation'
import './css/Chat.css'
import useActiveState from '../../lib/useActiveState'
import { redux } from '../../general'
import Read from './Read'

const tabItems = [
  { key: 'fruits', title: '群聊' },
  { key: 'vegetables', title: '社区' }
]

export default function Chat(props) {

  const swiperRef = useRef()
  const [activeIndex, setActiveIndex] = useState(0)
  const [user] = useActiveState('user')
  const [logined] = useActiveState('im-logined')

  return (
    <div className='screen-chat-index'>
      {activeIndex == 0 && user.isLogin && logined ? <Read active={props.active}></Read> :
        <div className='chat-read' onClick={() => {
          redux.dispatch({
            type: 'clearChatUnRead',
            data: {
              clearChatUnRead: true
            }
          })
        }}></div>
      }
      <div style={{ backgroundColor: '#fff' }}>
        <SafeArea position='top'></SafeArea>
      </div>
      <div>
        <Tabs
          style={{
            '--active-line-height': '0',
            '--title-font-size': '16px',
            '--active-title-color': '#282828'
          }}
          stretch={false}
          activeKey={tabItems[activeIndex].key}
          onChange={key => {
            const index = tabItems.findIndex(item => item.key === key)
            setActiveIndex(index)
            swiperRef.current?.swipeTo(index)
          }}
        >
          {tabItems.map(item => (
            <Tabs.Tab title={item.title} key={item.key} />
          ))}
        </Tabs>
        <Swiper
          allowTouchMove={false}
          direction='horizontal'
          indicator={() => null}
          ref={swiperRef}
          defaultIndex={activeIndex}
          onIndexChange={index => {
            setActiveIndex(index)
          }}
        >
          <Swiper.Item>
            <div className='chat-container'>
              {user.isLogin ? <Conversation></Conversation> : <Session icon="hot"></Session>}
            </div>
          </Swiper.Item>
          <Swiper.Item>
            <div className='chat-container'>
              <Community></Community>
            </div>
          </Swiper.Item>
        </Swiper>
      </div>
    </div>
  )
}
